"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitTestAutoTestStep = exports.pytestCaptureOutputModes = void 0;
const codec = __importStar(require("purify-ts/Codec"));
const api = __importStar(require("@codegrade/api"));
const maybe_1 = require("@codegrade/maybe");
const utils_1 = require("@codegrade/utils");
const utils_2 = require("@/utils");
const base_1 = require("./base");
const utils_3 = require("./utils");
const junit5MetadataCodec = codec.Codec.interface({
    javaArguments: codec.string,
    testClasses: codec.string,
    junitArguments: codec.string,
});
exports.pytestCaptureOutputModes = Object.freeze([
    'no',
    'log',
    'system-out',
    'system-err',
    'out-err',
    'all',
]);
const pytestMetadataCodec = codec.Codec.interface({
    filesToTest: codec.string,
    captureOutput: utils_1.parsers.maybe(codec.exactly(...exports.pytestCaptureOutputModes)),
    captureOutputPassing: codec.boolean,
    setPythonPath: codec.boolean,
    pytestArguments: codec.string,
});
const genericMetadataCodec = codec.Codec.interface({
    args: codec.optional(codec.string),
});
function metadataCodecWithGenericFallback(baseCodec, fromGeneric) {
    return codec.Codec.custom({
        decode: (value) => baseCodec
            .decode(value)
            .chainLeft(err => genericMetadataCodec.decode(value).bimap(() => err, fromGeneric)),
        encode: baseCodec.encode,
    });
}
const phpunitMetadataCodec = metadataCodecWithGenericFallback(codec.Codec.interface({
    filesToTest: codec.string,
    phpunitExecutable: utils_1.parsers.maybe(codec.string),
    phpunitArguments: codec.string,
}), ({ args }) => ({
    filesToTest: '',
    phpunitExecutable: maybe_1.Maybe.empty(),
    phpunitArguments: args ?? '',
}));
const xunitMetadataCodec = metadataCodecWithGenericFallback(codec.Codec.interface({
    testProject: codec.string,
    xunitArguments: codec.string,
}), ({ args }) => ({
    testProject: '',
    xunitArguments: args ?? '',
}));
const pytestParser = codec.Codec.interface({
    wrapper: codec.exactly('cg_pytest'),
    metadata: pytestMetadataCodec,
});
const junit5Parser = codec.Codec.interface({
    wrapper: codec.exactly('cg_junit5'),
    metadata: junit5MetadataCodec,
});
const phpunitParser = codec.Codec.interface({
    wrapper: codec.exactly('cg_phpunit'),
    metadata: phpunitMetadataCodec,
});
const xunitParser = codec.Codec.interface({
    wrapper: codec.exactly('cg_xunit'),
    metadata: xunitMetadataCodec,
});
const genericParser = codec.Codec.interface({
    wrapper: codec.optional(codec.exactly('custom', 'cg_check', 'cg_junit4', 'cg_jest', 'cg_moxunit', 'cg_mocha', 'cg_quickcheck', 'cg_semgrep')),
    metadata: codec.optional(genericMetadataCodec),
});
const wrapperAndMetadataParser = codec.oneOf([
    pytestParser,
    junit5Parser,
    phpunitParser,
    xunitParser,
    genericParser,
]);
const dataParser = codec.intersect(api.JunitTestBaseData, wrapperAndMetadataParser);
class UnitTestAutoTestStep extends base_1.BaseAutoTestStep {
    parseInputData(data) {
        return maybe_1.Maybe.fromEither(dataParser.decode(data))
            .filter(res => res.metadata != null)
            .orDefaultLazy(() => maybe_1.Maybe.fromFalsy(data.program).caseOf({
            Just: program => UnitTestAutoTestStep.getDefaultData('custom', program),
            Nothing: () => UnitTestAutoTestStep.getDefaultData(undefined, ''),
        }));
    }
    static getDefaultData(wrapper, program) {
        switch (wrapper) {
            case 'cg_junit5':
                return {
                    wrapper,
                    metadata: {
                        javaArguments: '',
                        junitArguments: '',
                        testClasses: '',
                    },
                    program,
                };
            case 'cg_pytest':
                return {
                    wrapper,
                    metadata: {
                        filesToTest: '',
                        captureOutput: maybe_1.Maybe.empty(),
                        captureOutputPassing: false,
                        setPythonPath: true,
                        pytestArguments: '',
                    },
                    program,
                };
            case 'cg_phpunit':
                return {
                    wrapper,
                    metadata: {
                        filesToTest: '',
                        phpunitExecutable: maybe_1.Maybe.empty(),
                        phpunitArguments: '',
                    },
                    program,
                };
            case 'cg_xunit':
                return {
                    wrapper,
                    metadata: {
                        testProject: '',
                        xunitArguments: '',
                    },
                    program,
                };
            default:
                return {
                    wrapper,
                    metadata: undefined,
                    program,
                };
        }
    }
    static stepDataEquals(a, b) {
        switch (a.wrapper) {
            case undefined:
                return a.program.trim() === b.program.trim();
            case 'custom':
            case 'cg_check':
            case 'cg_junit4':
            case 'cg_jest':
            case 'cg_moxunit':
            case 'cg_mocha':
            case 'cg_quickcheck':
            case 'cg_semgrep': {
                if (a.wrapper !== b.wrapper) {
                    return false;
                }
                if (a.program.trim() !== b.program.trim()) {
                    return false;
                }
                const metadataA = a.metadata;
                const metadataB = b.metadata;
                if (metadataA == null || metadataB == null) {
                    return (metadataA == null) === (metadataB == null);
                }
                return (0, utils_2.keysOfSlow)(['args']).every(key => {
                    switch (key) {
                        case 'args':
                            return metadataA[key]?.trim() === metadataB[key]?.trim();
                        default:
                            return utils_2.AssertionError.assertNever(key);
                    }
                });
            }
            case 'cg_pytest': {
                if (a.wrapper !== b.wrapper) {
                    return false;
                }
                return (0, utils_2.keysOfSlow)([
                    'pytestArguments',
                    'filesToTest',
                    'captureOutput',
                    'captureOutputPassing',
                    'setPythonPath',
                ]).every(key => {
                    switch (key) {
                        case 'pytestArguments':
                        case 'filesToTest':
                            return a.metadata[key].trim() === b.metadata[key].trim();
                        case 'captureOutput':
                            return a.metadata[key].equals(b.metadata[key]);
                        case 'captureOutputPassing':
                        case 'setPythonPath':
                            return a.metadata[key] === b.metadata[key];
                        default:
                            return utils_2.AssertionError.assertNever(key);
                    }
                });
            }
            case 'cg_junit5': {
                if (a.wrapper !== b.wrapper) {
                    return false;
                }
                return (0, utils_2.keysOfSlow)([
                    'javaArguments',
                    'testClasses',
                    'junitArguments',
                ]).every(key => {
                    switch (key) {
                        case 'javaArguments':
                        case 'testClasses':
                        case 'junitArguments':
                            return a.metadata[key].trim() === b.metadata[key].trim();
                        default:
                            return utils_2.AssertionError.assertNever(key);
                    }
                });
            }
            case 'cg_phpunit': {
                if (a.wrapper !== b.wrapper) {
                    return false;
                }
                return (0, utils_2.keysOfSlow)([
                    'filesToTest',
                    'phpunitExecutable',
                    'phpunitArguments',
                ]).every(key => {
                    switch (key) {
                        case 'filesToTest':
                        case 'phpunitArguments':
                            return a.metadata[key].trim() === b.metadata[key].trim();
                        case 'phpunitExecutable':
                            return a.metadata[key].equals(b.metadata[key]);
                        default:
                            return utils_2.AssertionError.assertNever(key);
                    }
                });
            }
            case 'cg_xunit': {
                if (a.wrapper !== b.wrapper) {
                    return false;
                }
                return (0, utils_2.keysOfSlow)(['testProject', 'xunitArguments']).every(key => {
                    switch (key) {
                        case 'testProject':
                        case 'xunitArguments':
                            return a.metadata[key] === b.metadata[key];
                        default:
                            return utils_2.AssertionError.assertNever(key);
                    }
                });
            }
            default:
                return utils_2.AssertionError.assertNever(a);
        }
    }
    getDataToSave() {
        const errs = this._checkProgramNotEmpty();
        switch (this.data.wrapper) {
            case 'cg_junit5': {
                const testClasses = this.data.metadata.testClasses ?? '';
                if (testClasses.trim() === '') {
                    errs.push('At least one test class must be present.');
                }
                break;
            }
            case 'cg_pytest': {
                const filesToTest = this.data.metadata?.filesToTest ?? '';
                if (filesToTest.trim() === '') {
                    errs.push('At least one test file must be present.');
                }
                break;
            }
            case 'cg_phpunit': {
                const filesToTest = this.data.metadata?.filesToTest ?? '';
                if (filesToTest.trim() === '') {
                    errs.push('At least one test file must be present.');
                }
                break;
            }
            case 'cg_xunit': {
                const testProject = this.data.metadata?.testProject ?? '';
                if (testProject.trim() === '') {
                    errs.push('A test project must be present.');
                }
                break;
            }
            default:
                break;
        }
        const outputData = api.JunitTestData.unsafeDecode(dataParser.encode(this.data));
        return (0, utils_3.mergeEithers)(this._baseGetDataToSave(), (0, utils_3.errOrData)(errs, {
            data: outputData,
            type: this.type,
        }));
    }
}
exports.UnitTestAutoTestStep = UnitTestAutoTestStep;
